package com.appsyde.shared.core.presentation

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel

open class BaseViewModel {
    // Use Default for Multiplatform runtime (Main dispatcher may not be available on JS)
    protected val viewModelScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)

    open fun onCleared() {
        viewModelScope.coroutineContext.cancel()
    }
}